import { render } from "./ChartVisitComponent.vue?vue&type=template&id=5584e66c&scoped=true"
import script from "./ChartVisitComponent.vue?vue&type=script&lang=js"
export * from "./ChartVisitComponent.vue?vue&type=script&lang=js"

import "./ChartVisitComponent.vue?vue&type=style&index=0&id=5584e66c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5584e66c"

export default script